import { useState, FC } from 'react';
import { useSnackbar } from 'notistack';
import { Box, Fade, ButtonGroup, Button, MenuItem } from '@mui/material';
import { Close, Restore } from '@mui/icons-material';
import { Modal, Loader, SMBSelect } from '../../../components';
import { resetFieldWalkthrough } from '../../../fetch';
import { IFieldWalkthrough } from '../../../models';

interface IResetFieldWalkthroughModal {
  open: boolean;
  onClose: () => void;
  fetchBuilds: () => void;
  fieldWalkthroughs: IFieldWalkthrough[];
}

export const ResetFieldWalkthroughModal: FC<IResetFieldWalkthroughModal> = ({
  open,
  onClose,
  fetchBuilds,
  fieldWalkthroughs
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [isResetting, setResetting] = useState(false);
  const [fieldWalkthroughId, setFieldWalkthroughId] = useState<number | string>('');
  return (
    <Modal open={open} onClose={onClose} maxWidth="sm" title="Reset Field Walkthrough">
      <Fade in={open}>
        <Box mt={1}>
          {isResetting && (
            <Loader position="centered" type="overlay">
              Resetting...
            </Loader>
          )}
          <SMBSelect
            name={`fieldWalkthroughId`}
            label="Field Walkthrough"
            variant="outlined"
            value={fieldWalkthroughId}
            handleClear={() => setFieldWalkthroughId('')}
            onChange={({ target: { value } }) => {
              setFieldWalkthroughId(Number(value));
            }}
          >
            {fieldWalkthroughs?.map((walk, index) => {
              return (
                <MenuItem key={`${index}`} value={walk.fieldWalkthroughId}>
                  {walk.planDescription}
                </MenuItem>
              );
            })}
          </SMBSelect>
          <Box mt={1} display="flex" alignItems="center" justifyContent="flex-end">
            <ButtonGroup>
              <Button
                color="primary"
                variant="contained"
                disabled={isResetting || !fieldWalkthroughId}
                startIcon={<Restore />}
                onClick={async () => {
                  setResetting(true);
                  try {
                    await resetFieldWalkthrough(fieldWalkthroughId);
                    enqueueSnackbar(`Field Walkthrough reset!`, {
                      variant: 'success'
                    });
                    onClose();
                    fetchBuilds();
                  } catch (error) {
                    enqueueSnackbar(
                      error?.Detail ?? 'Error resetting field walkthrough, please try again.',
                      {
                        variant: 'error'
                      }
                    );
                  } finally {
                    setResetting(false);
                  }
                }}
              >
                Reset
              </Button>
              <Button color="inherit" variant="contained" startIcon={<Close />} onClick={onClose}>
                Cancel
              </Button>
            </ButtonGroup>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
};
